module.exports = __webpack_public_path__ + "static/classhook-footer-c4e49e613835140a5ae8d762069566d6.jpg";